import { Mail, MessageCircle, Clock } from "lucide-react";
import { PageShell } from "../components/layout/PageShell";
import { SOCIAL_LINKS } from "../data/social";

const CONTACT_EMAIL = "heshaurastore@gmail.com";

export default function ContactPage() {
  const activeSocial = SOCIAL_LINKS.filter((s) => s.url);
  return (
    <PageShell
      testId="contact-page"
      overline="Say Hello"
      title="Contact HESHAURA"
      intro="Questions about an order, a bracelet or a gift? Our small studio team is glad to help."
      path="/contact"
    >
      <div className="grid gap-6 sm:grid-cols-2">
        <div className="border border-brand-sand bg-brand-surface p-8" data-testid="contact-email-card">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-gold/10 text-brand-gold">
            <Mail className="h-5 w-5" strokeWidth={1.6} />
          </span>
          <h2 className="mt-5 font-serif text-2xl text-brand-charcoal">Email us</h2>
          <p className="mt-2 text-sm leading-relaxed text-brand-stone">
            For orders, care advice or anything else, write to us and we'll reply within 1–2 business days.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="contact-email-link"
            className="mt-4 inline-block text-sm font-semibold text-brand-gold underline-offset-4 hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className="border border-brand-sand bg-brand-surface p-8" data-testid="contact-whatsapp-card">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-gold/10 text-brand-gold">
            <MessageCircle className="h-5 w-5" strokeWidth={1.6} />
          </span>
          <h2 className="mt-5 font-serif text-2xl text-brand-charcoal">WhatsApp</h2>
          <p className="mt-2 text-sm leading-relaxed text-brand-stone">
            Prefer to chat? Reply to your order confirmation on WhatsApp for quick help with orders and styling.
          </p>
        </div>
      </div>

      <div className="mt-6 flex items-start gap-3 border-l-2 border-brand-gold bg-brand-surface p-6 text-sm leading-relaxed text-brand-stone" data-testid="contact-hours">
        <Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" />
        <p>Studio hours: Monday–Saturday, 10am–6pm IST. Every bracelet is handcrafted in small batches in India.</p>
      </div>

      {activeSocial.length > 0 && (
        <div className="mt-10" data-testid="contact-social">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-brand-charcoal">Follow HESHAURA</p>
          <div className="mt-4 flex flex-wrap gap-2.5">
            {activeSocial.map(({ key, label, icon, url }) => (
              <a
                key={key}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
                data-testid={`contact-social-${key}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-brand-gold/40 text-brand-charcoal transition-[color,border-color,background-color] duration-300 hover:border-brand-gold hover:bg-brand-gold hover:text-brand-cream"
              >
                <i className={`${icon} text-[15px]`} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      )}
    </PageShell>
  );
}
